import classNames from 'classnames'
import React, { ComponentPropsWithoutRef, PropsWithChildren } from 'react'

type PanelProps = PropsWithChildren<{
  title?: string
  className?: string
}> &
  ComponentPropsWithoutRef<'div'>

const Panel: React.FC<PanelProps> = ({ title, className, children, ...props }) => {
  return (
    <div className={classNames(className || 'bg-white', 'divide-y divide-gray-200 rounded-lg shadow')} {...props}>
      {title && <div className="px-4 py-3 sm:p-4">{title}</div>}
      <div className="px-4 py-3 sm:p-4">{children}</div>
    </div>
  )
}

export default Panel
